import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../../data.service';

/**
 *  ÜGYFÉLKÖR – önálló vagy kapcsolt mód egy alrendszerben (backend/ugyfeltorzs.js).
 *
 *  Kapcsolt: az ügyfelek a Könyvelésből jönnek (a Könyvelés a központ). Önálló: saját ügyfélkör,
 *  Könyvelés nélkül. Alapból AUTOMATIKUS: kapcsolt, ha a Könyvelés aktív az intézményben. Váltáskor
 *  az ügyfelek ugyanazzal az azonosítóval kerülnek át, így az adataik megmaradnak. Csak a modul
 *  adminja válthat (a kiszolgáló dönt).
 */
@Component({
  selector: 'app-ugyfelkor-beallitas',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './ugyfelkor-beallitas.component.html',
  styleUrls: ['./ugyfelkor-beallitas.component.scss'],
})
export class UgyfelkorBeallitasComponent implements OnChanges {
  @Input() alrendszer = '';
  @Output() valtozott = new EventEmitter<any>();
  allapot: any = null;
  valasztott = 'auto';
  fut = false;
  hiba = '';
  uzenet = '';

  private intezmeny = '';

  constructor(private http: HttpClient, private data: DataService) {}

  private get ut() { return `/api/ugyfeltorzs/${this.alrendszer}/mod/${this.intezmeny}`; }

  async ngOnChanges() {
    if (!this.alrendszer) return;
    //  A tárolt intézményből: közvetlen URL-betöltéskor az app-keret még nem regisztrált.
    this.intezmeny = (await this.data.getFromStorage('sajatIntezmeny'))?.intezmenyId || '';
    if (!this.intezmeny) return;
    try {
      this.allapot = await firstValueFrom(this.http.get(this.ut));
      this.valasztott = this.allapot.beallitott || 'auto';
    } catch (e: any) { this.allapot = null; this.hiba = e?.error?.error || ''; }
  }
  modNev(m: string) { return m === 'kapcsolt' ? 'kapcsolt (a Könyvelés ügyfelei)' : m === 'onallo' ? 'önálló (saját ügyfélkör)' : m; }

  async ment() {
    this.fut = true; this.hiba = ''; this.uzenet = '';
    try {
      const r: any = await firstValueFrom(this.http.put(this.ut, { mod: this.valasztott }));
      this.allapot = { ...this.allapot, ...r };
      const resz = [`Az ügyfélkör most ${this.modNev(r.mod)}.`];
      if (r.atvett) resz.push(`${r.atvett} ügyfél átkerült, ugyanazzal az azonosítóval.`);
      if (r.utkozes?.length) resz.push(`${r.utkozes.length} ügyfél adószáma a Könyvelésben már egy másik ügyfélé – ezeket nem vontam össze: ${r.utkozes.map((u: any) => `${u.nev} (Könyvelés: ${u.naplo_nev})`).join(', ')}.`);
      this.uzenet = resz.join(' ');
      this.valtozott.emit(r);
    } catch (e: any) { this.hiba = e?.error?.error || 'A módváltás nem sikerült.'; }
    this.fut = false;
  }
}
